<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <span>入库单扫描</span>
      <el-divider/>
      <el-form ref="form" class="form" label-width="80px" @submit.native.prevent>
        <el-form-item label="入库单号">
          <el-input
              ref="billNoInput"
              v-model.trim="billNo"
              style="width: 300px"
              placeholder="请扫描入库单"
              @keyup.enter.native="scanHandle"/>
        </el-form-item>
      </el-form>
      <div>入库单明细</div>
      <el-divider/>
      <el-button
          type="primary"
          style="margin-bottom: 10px"
          :loading="loading"
          :disabled="!data.details.length"
          @click="postHandle">
        保存
      </el-button>
      <el-table stripe border :data="data.details" style="width: 100%">
        <el-table-column prop="materialNo" label="物料编号" width="140" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" min-width="300" show-overflow-tooltip/>
        <el-table-column prop="specification" label="物料规格" min-width="280" show-overflow-tooltip/>
        <el-table-column prop="unitName" label="单位" width="80" align="center"/>
        <el-table-column prop="quantity" label="入库数量" width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" class="inputCenter" placeholder="请输入入库数量"/>
          </template>
        </el-table-column>
        <el-table-column prop="locationName" label="库位名称" width="240">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择库位">
              <el-button slot="append" @click="chooseHandle(scope.row, scope.$index)"> 选择 </el-button>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <warehouse-select ref="warehouseSelect" @select="kwSelect"/>
  </el-container>
</template>
<script>
  import WarehouseSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  export default {
    name: "StoreScanIndex",
    components: {
      WarehouseSelect,
    },
    data() {
      return {
        loading: false,
        billNo: "",
        data: {
          details: [],
        },
        currentIndex: "",
        currentRow: "",
      };
    },

    mounted() {
      this.$refs.billNoInput.focus();
    },

    methods: {
      // 扫描出库单号
      scanHandle() {
        if (!this.billNo) {
          this.$confirm("入库单号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.get("basic", `scanRecords/scanInStockBill/${this.billNo}`).then((resp) => {
          if (resp.success) {
            this.data = resp.data;
          }
        });
      },

      // 保存
      postHandle() {
        const result = this.data.details.some((item) => !item.quantity);
        const resultTwo = this.data.details.some((item) => !item.locationId);
        if (result) {
          this.$confirm("入库数量不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (resultTwo) {
          this.$confirm("库位不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.loading = true;
        this.$http
          .post("basic", "inStockBills/inStockBillAction", this.data)
          .then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.billNo = "";
              this.data.details = [];
              this.loading = false;
            }else {
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },

      chooseHandle(row, index) {
        this.currentIndex = index;
        this.currentRow = row;
        this.$refs.warehouseSelect.open();
      },

      // 选择库位
      kwSelect(row) {
        this.currentRow.locationId = row.pkId;
        this.currentRow.locationName = row.warehouseAreaName;
        this.$set(this.data.details, this.currentIndex, this.currentRow);
      },
    },
  };
</script>
